import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import loader from "../loder.gif"
import Loader from 'react-js-loader'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import ReactSwitch from 'react-switch'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Swal from 'sweetalert2'
import { apiRequest } from '../../store/allApi'



export default function Permission() {
  let { id } = useParams();
  const [loading, setLoading] = useState(false)
  const [agent, setAgent] = useState('')
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const [dashboard, setdashboard] = useState(false)
  const [earnings, setearnings] = useState(false)
  const [allAdmins, setallAdmins] = useState(false)
  const [newAdmin, setnewAdmin] = useState(false)
  const [sitesettings, setsitesettings] = useState(false)
  const [Gatewaysettings, setGatewaysettings] = useState(false)
  const [addBankDetail, setaddBankDetail] = useState(false)
  const [viewBankDetail, setviewBankDetail] = useState(false)
  const [agentdashboard, setagentdashboard] = useState(false)
  const [allUsers, setallUsers] = useState(false)
  const [blockUser, setblockUser] = useState(false)
  const [pendingKyc, setpendingKyc] = useState(false)
  const [completedKyc, setcompletedKyc] = useState(false)
  const [rejectKyc, setrejectKyc] = useState(false)
  const [supportChat, setsupportChat] = useState(false)
  const [pushNotification, setpushNotification] = useState(false)
  const [legalData, setlegalData] = useState(false)
  const [userBankDetail, setBankShow] = useState(false)
  const [allChallenges, setallChallenges] = useState(false)
  const [completedChallenges, setcompletedChallenges] = useState(false)
  const [conflictChallenges, setconflictChallenges] = useState(false)
  const [cancelledChallenges, setcancelledChallenges] = useState(false)
  const [challengesRed, setchallengesRed] = useState(false)
  const [runningChallenges, setrunningChallenges] = useState(false)
  const [pendingChallenges, setpendingChallenges] = useState(false)
  const [newChallenge, setnewChallenge] = useState(false)
  const [bonus, setbonus] = useState(false)
  const [bonusReport, setbonusReport] = useState(false)
  const [bonusHistory, setbonusHistory] = useState(false)
  const [penalty, setpenalty] = useState(false)
  const [penaltyHistory, setpenaltyHis] = useState(false)
  const [penaltyReport, setpenaltyReport] = useState(false)
  const [depositRequest, setdepositRequest] = useState(false)
  const [depositHistory, setdepositHistory] = useState(false)
  const [manualDepositHistory, setmanualDepositHistory] = useState(false)
  const [depositReport, setdepositReport] = useState(false)
  const [agentWallet, setAgentWallet] = useState(false)
  const [allWithdrawlRequests, setallWithdrawlRequests] = useState(false)
  const [manualWithdrawlRequest, setmanualWithdrawlRequest] = useState(false)
  const [gatewayWithdrawlRequest, setgatewayWithdrawlRequest] = useState(false)
  const [withdrawlHistory, setwithdrawlHistory] = useState(false)
  const [withdrawlReport, setwithdrawlReport] = useState(false)
  const [withdrawVerify, setWithdrawVerify] = useState(false)
  const [withdrawRedZone, setwithdrawRedZone] = useState(false)
  const [Security_Deposit_wallet, setSecurityDeposit] = useState(false)
  const [ManualDeposit_wallet, setManualDepositwallet] = useState(false)
  const [depositVerify, setDepositVerify] = useState(false)
  const [allAgent, setallAgent] = useState(false)
  const [withdrawlMinLimit, setwithdrawlMinLimit] = useState(10)
    const [withdrawlMaxLimit, setwithdrawlMaxLimit] = useState(100)
    const [depositMinLimit, setdepositMinLimit] = useState(10)
    const [depositMaxLimit, setdepositMaxLimit] = useState(100)

    const permission =async () => {
      setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`agent-permission/${id}`,"GET", null,headers)
     if (res.data) {
         setLoading(false)
        setdashboard(res?.data?.data?.dashboard)
        setearnings(res?.data?.data?.earnings)
        setallAdmins(res?.data?.data?.allAdmins)
        setnewAdmin(res?.data?.data?.newAdmin)
        setsitesettings(res?.data?.data?.sitesettings)
        setGatewaysettings(res?.data?.data?.Gatewaysettings)
        setaddBankDetail(res?.data?.data?.addBankDetail)
        setviewBankDetail(res?.data?.data?.viewBankDetail)
        setagentdashboard(res?.data?.data?.agentdashboard)
        setallUsers(res?.data?.data?.allUsers)
        setblockUser(res?.data?.data?.blockUser)
        setpendingKyc(res?.data?.data?.pendingKyc)
        setcompletedKyc(res?.data?.data?.completedKyc)
        setrejectKyc(res?.data?.data?.rejectKyc)
        setsupportChat(res?.data?.data?.supportChat)
        setpushNotification(res?.data?.data?.pushNotification)
        setlegalData(res?.data?.data?.legalData)
        setBankShow(res?.data?.data?.userBankDetail)
        setallChallenges(res?.data?.data?.allChallenges)
        setcompletedChallenges(res?.data?.data?.completedChallenges)
        setconflictChallenges(res?.data?.data?.conflictChallenges)
        setcancelledChallenges(res?.data?.data?.cancelledChallenges)
        setchallengesRed(res?.data?.data?.challengesRed)
        setrunningChallenges(res?.data?.data?.runningChallenges)
        setpendingChallenges(res?.data?.data?.pendingChallenges)
        setnewChallenge(res?.data?.data?.newChallenge)
        setbonus(res?.data?.data?.bonus)
        setbonusReport(res?.data?.data?.bonusReport)
        setbonusHistory(res?.data?.data?.bonusHistory)
        setpenalty(res?.data?.data?.penalty)
        setpenaltyReport(res?.data?.data?.penaltyReport)
        setpenaltyHis(res?.data?.data?.penaltyHistory)
        setdepositRequest(res?.data?.data?.depositRequest)
        setdepositHistory(res?.data?.data?.depositHistory)
        setmanualDepositHistory(res?.data?.data?.manualDepositHistory)
        setdepositReport(res?.data?.data?.depositHistory)
        setSecurityDeposit(res?.data?.data?.Security_Deposit_wallet)
        setallWithdrawlRequests(res?.data?.data?.allWithdrawlRequests)
        setmanualWithdrawlRequest(res?.data?.data?.manualWithdrawlRequest)
        setgatewayWithdrawlRequest(res?.data?.data?.gatewayWithdrawlRequest)
        setwithdrawlHistory(res?.data?.data?.withdrawlHistory)
        setwithdrawlReport(res?.data?.data?.withdrawlReport)
        setWithdrawVerify(res?.data?.data?.withdrawVerify)
        setwithdrawRedZone(res?.data?.data?.withdrawRedZone)
        setAgentWallet(res?.data?.data?.agentWallet)
        setManualDepositwallet(res?.data?.data?.ManualDeposit_wallet)
        setDepositVerify(res?.data?.data?.depositVerify)
        setallAgent(res?.data?.data?.allAgent)
        setwithdrawlMinLimit(res?.data?.data?.withdrawlMinLimit)
        setwithdrawlMaxLimit(res?.data?.data?.withdrawlMaxLimit)
        setdepositMinLimit(res?.data?.data?.depositMinLimit)
        setdepositMaxLimit(res?.data?.data?.depositMaxLimit)
     }
        } catch (e) {
             setLoading(false)
        console.log(e)
        }
        finally {
        }
    }

  useEffect(() => {
    permission()
  }, [])


  const AllowPermission = async(id) => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
try {
  const res = await apiRequest(`agent-permission/assign`,"POST", 
    {
          "agentId": id,
          "permissions": {
            dashboard,
            earnings,
            allAdmins,
            newAdmin,
            sitesettings,
            Gatewaysettings,
            addBankDetail,
            viewBankDetail,
            agentdashboard,
            allUsers,
            blockUser,
            pendingKyc,
            completedKyc,
            rejectKyc,
            supportChat,
            pushNotification,
            legalData,
            userBankDetail,
            allChallenges,
            completedChallenges,
            conflictChallenges,
            cancelledChallenges,
            challengesRed,
            runningChallenges,
            pendingChallenges,
            newChallenge,
            bonus,
            bonusReport,
            bonusHistory,
            penalty,
            penaltyHistory,
            penaltyReport,
            depositRequest,
            depositHistory,
            manualDepositHistory,
            depositHistory,
            allWithdrawlRequests,
            manualWithdrawlRequest,
            gatewayWithdrawlRequest,
            withdrawlHistory,
            agentWallet,
            withdrawlReport,
            withdrawVerify,
            withdrawRedZone,
            Security_Deposit_wallet,
            ManualDeposit_wallet,
            depositVerify,
            allAgent,
            withdrawlMinLimit,
            withdrawlMaxLimit,
            depositMinLimit,
            depositMaxLimit
          }
        }
    ,headers)
 if (res.data) {
  Swal.fire({
            text: "Permission Submit Success",
            icon: "success"
          });
 }
    } catch (e) {
      console.log(e)
    }
    finally {
    }
  }

  const ChangeDashBoard = val => {
    setdashboard(val)
  }
  const ChangeEarning = val => {
    setearnings(val)
  }
  const ChangeAllAdmins = val => {
    setallAdmins(val)
  }
  const ChangeNewAdmin = val => {
    setnewAdmin(val)
  }
  const ChangeSitesettings = val => {
    setsitesettings(val)
  }
  const ChangeGatewaysettings = val => {
    setGatewaysettings(val)
  }
  const ChangeaddBankDetail = val => {
    setaddBankDetail(val)
  }
  const ChangeviewBankDetail = val => {
    setviewBankDetail(val)
  }
  const Changeagentdashboard = val => {
    setagentdashboard(val)
  }
  const ChangeAllUsers = val => {
    setallUsers(val)
  }
  const ChangeblockUser = val => {
    setblockUser(val)
  }
  const ChangependingKyc = val => {
    setpendingKyc(val)
  }
  const ChangecompletedKyc = val => {
    setcompletedKyc(val)
  }
  const ChangerejectKyc = val => {
    setrejectKyc(val)
  }
  const ChangesupportChat = val => {
    setsupportChat(val)
  }
  const ChangepushNotification = val => {
    setpushNotification(val)
  }
  const ChangelegalData = val => {
    setlegalData(val)
  }
  const ChangeBankDetail = val => {
    setBankShow(val)
  }
  const ChangeallChallenges = val => {
    setallChallenges(val)
  }
  const ChangecompletedChallenges = val => {
    setcompletedChallenges(val)
  }
  const ChangeconflictChallenges = val => {
    setconflictChallenges(val)
  }
  const ChangecancelledChallenges = val => {
    setcancelledChallenges(val)
  }
  const ChangechallengesRed = val => {
    setchallengesRed(val)
  }
  const ChangerunningChallenges = val => {
    setrunningChallenges(val)
  }
  const ChangependingChallenges = val => {
    setpendingChallenges(val)
  }
  const ChangenewChallenge = val => {
    setnewChallenge(val)
  }
  const Changebonus = val => {
    setbonus(val)
  }
  const ChangebonusReport = val => {
    setbonusReport(val)
  }
  const ChangebonusHistory = val => {
    setbonusHistory(val)
  }
  const Changepenalty = val => {
    setpenalty(val)
  }
  const ChangepenaltyHis = val => {
    setpenaltyHis(val)
  }
  const ChangepenaltyReport = val => {
    setpenaltyReport(val)
  }
  const ChangedepositRequest = val => {
    setdepositRequest(val)
  }
  const ChangedepositHistory = val => {
    setdepositHistory(val)
  }
  const ChangemanualDepositHistory = val => {
    setmanualDepositHistory(val)
  }
  const ChangedepositReport = val => {
    setdepositReport(val)
  }
  const ChangeSecurityDeposit = val => {
    setAgentWallet(val)
  }
  const ChangeallWithdrawlRequests = val => {
    setallWithdrawlRequests(val)
  }
  const ChangemanualWithdrawlRequest = val => {
    setmanualWithdrawlRequest(val)
  }
  const ChangegatewayWithdrawlRequest = val => {
    setgatewayWithdrawlRequest(val)
  }
  const ChangewithdrawlHistory = val => {
    setwithdrawlHistory(val)
  }
  const ChangewithdrawlReport = val => {
    setwithdrawlReport(val)
  }
  const verifyWithdraw = val => {
    setWithdrawVerify(val)
  }
  const withRedZone = val => {
    setwithdrawRedZone(val)
  }
  const ChangeManual = val => {
    setManualDepositwallet(val)
  }
  const verifyDeposit = val => {
    setDepositVerify(val)
  }
  const ChangeSecurity = val => {
    setSecurityDeposit(val)
  }
  const ChangeallAgent = val => {
    setallAgent(val)
  }

  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {/* <h4 className='text-uppercase font-weight-bold my-3'>all Admin list</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card'>
            <div className='card-body  table_bg'>
            <div className='permission-header'>
            <h4 className='dashboard_heading'>All Agent Permission</h4>
             <button onClick={() => AllowPermission(id)} className='btn btn-success'>Save Changes</button>
              </div>  

              <div className='row'>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Dashboard</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={dashboard}
                              onChange={ChangeDashBoard}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Earning</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={earnings}
                              onChange={ChangeEarning}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Alladmin</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={allAdmins}
                              onChange={ChangeAllAdmins}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>New Admin</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={newAdmin}
                              onChange={ChangeNewAdmin}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>All Agent</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={allAgent}
                              onChange={ChangeallAgent}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Site settings</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={sitesettings}
                              onChange={ChangeSitesettings}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Gateway settings</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={Gatewaysettings}
                              onChange={ChangeGatewaysettings}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Add Bank Detail</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={addBankDetail}
                              onChange={ChangeaddBankDetail}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>view Bank Detail</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={viewBankDetail}
                              onChange={ChangeviewBankDetail}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Agent dashboard</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={agentdashboard}
                              onChange={Changeagentdashboard}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>All Users</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={allUsers}
                              onChange={ChangeAllUsers}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Block User</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={blockUser}
                              onChange={ChangeblockUser}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Pending Kyc</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={pendingKyc}
                              onChange={ChangependingKyc}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Completed Kyc</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={completedKyc}
                              onChange={ChangecompletedKyc}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>reject Kyc</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={rejectKyc}
                              onChange={ChangerejectKyc}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {/* <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>support Chat</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={supportChat}
                              onChange={ChangesupportChat}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>push Notification</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={pushNotification}
                              onChange={ChangepushNotification}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div> */}
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>legal Data</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={legalData}
                              onChange={ChangelegalData}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Account Details</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={userBankDetail}
                              onChange={ChangeBankDetail}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>all Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={allChallenges}
                              onChange={ChangeallChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>completed Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={completedChallenges}
                              onChange={ChangecompletedChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>conflict Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={conflictChallenges}
                              onChange={ChangeconflictChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Cancelled Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={cancelledChallenges}
                              onChange={ChangecancelledChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Red Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={challengesRed}
                              onChange={ChangechallengesRed}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Running Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={runningChallenges}
                              onChange={ChangerunningChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Pending Challenges</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={pendingChallenges}
                              onChange={ChangependingChallenges}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>New Challenge</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={newChallenge}
                              onChange={ChangenewChallenge}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Bonus</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={bonus}
                              onChange={Changebonus}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Bonus Report</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={bonusReport}
                              onChange={ChangebonusReport}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {/* <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Bonus History</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={bonusHistory}
                              onChange={ChangebonusHistory}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div> */}
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Penalty</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={penalty}
                              onChange={Changepenalty}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {/* <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Penalty History</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={penaltyHistory}
                              onChange={ChangepenaltyHis}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div> */}
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Penalty Report</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={penaltyReport}
                              onChange={ChangepenaltyReport}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                {/* <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Deposit Request</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={depositRequest}
                              onChange={ChangedepositRequest}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div> */}
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Security Deposit wallet</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={Security_Deposit_wallet}
                              onChange={ChangeSecurity}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Manual Deposit wallet</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={ManualDeposit_wallet}
                              onChange={ChangeManual}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Deposit Verify</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={depositVerify}
                              onChange={verifyDeposit}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Deposit History</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={depositHistory}
                              onChange={ChangedepositHistory}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Manual Deposit History</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={manualDepositHistory}
                              onChange={ChangemanualDepositHistory}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Deposit  Report</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={depositReport}
                              onChange={ChangedepositReport}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Agent Wallet</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={agentWallet}
                              onChange={ChangeSecurityDeposit}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>All Withdrawl Requests</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={allWithdrawlRequests}
                              onChange={ChangeallWithdrawlRequests}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Manual Withdrawl Request</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={manualWithdrawlRequest}
                              onChange={ChangemanualWithdrawlRequest}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Gateway Withdrawl Request</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={gatewayWithdrawlRequest}
                              onChange={ChangegatewayWithdrawlRequest}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl History</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={withdrawlHistory}
                              onChange={ChangewithdrawlHistory}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl Report</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={withdrawlReport}
                              onChange={ChangewithdrawlReport}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl Verify</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={withdrawVerify}
                              onChange={verifyWithdraw}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-4'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl Time-Red-Zone</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                          <h3 className='mb-2 font-rubik'>
                            <ReactSwitch
                              checked={withdrawRedZone}
                              onChange={withRedZone}
                              style={{ display: 'none' }}
                            />
                          </h3>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
               
                <div className='col-xl-3 col-sm-3 col-8'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>deposit Limit Min</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                        <Row
                          style={{ marginRight: '', marginTop: '10px' }}
                        >
                          
                          <Col className='col-sm-6 pb-3'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={depositMinLimit}
                              onChange={e =>
                                setdepositMinLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Mix-Limit'
                            />
                          </Col>
                        </Row>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-8'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>deposit Limit Max</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                        <Row
                          style={{ marginRight: '', marginTop: '10px' }}
                        >
                          
                          <Col className='col-sm-6 pb-3'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={depositMaxLimit}
                              onChange={e =>
                                setdepositMaxLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Max-Limit'
                            />
                          </Col>
                        </Row>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-8'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl Limit Min</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                        <Row
                          style={{ marginRight: '', marginTop: '10px' }}
                        >
                          
                          <Col className='col-sm-6 pb-3'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={withdrawlMinLimit}
                              onChange={e =>
                                setwithdrawlMinLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Mix-Limit'
                            />
                          </Col>
                        </Row>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className='col-xl-3 col-sm-3 col-12'>
                  <div className='card dashboard_small_card card_hover'>
                    <div className='card-header border-bottom-0'>
                      <h3 className='card-title'>Withdrawl Limit Max</h3>
                      <div className='card-options'> </div>
                    </div>
                    <div className='card-body pt-0'>
                      <div className=''>
                        <div className=''>
                        <Row
                          style={{ marginRight: '', marginTop: '10px' }}
                        >
                          
                          <Col className='col-sm-6 pb-3'>
                            {' '}
                            <input
                              type='text'
                              name='UpiMax'
                              value={withdrawlMaxLimit}
                              onChange={e =>
                                setwithdrawlMaxLimit(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter Max-Limit'
                            />
                          </Col>
                        </Row>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
